"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("./styles");
var _react2 = require("@emotion/react");
var _Text = _interopRequireDefault(require("../../../core/Text"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const MenuItem = ({
  small,
  icon,
  lightTheme,
  active,
  label,
  onClick,
  ...props
}) => {
  const theme = (0, _react2.useTheme)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.ListItem, {
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Wrapper, {
      role: "menuitem",
      "aria-current": active ? 'page' : undefined,
      nostyle: true,
      small: small,
      theme: theme,
      lightTheme: lightTheme,
      className: active ? 'active' : '',
      onClick: onClick,
      "data-tracking-name": "Sidemenu",
      "data-tracking-event": 'Menu click: ' + label,
      title: label,
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Span, {
        small: small,
        children: [icon, /*#__PURE__*/(0, _jsxRuntime.jsx)(_Text.default, {
          color: lightTheme ? theme.lightMenuTextColor : theme.defaultMenuTextColor,
          children: label
        })]
      })
    })
  });
};
var _default = exports.default = MenuItem;